import { createRequestClient, type RequestOptions } from '@njnorge/admin-common'

const defaultApiBaseUrl =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.DEV ? 'http://localhost:8000/api' : 'https://api.crst.njnorge.ltd/api')

const client = createRequestClient({
  defaultApiBaseUrl,
  tokenKey: 'admin_token',
  loginPath: '/login',
  namespace: 'admin',
})

export const request = client.request
export const normalizePath = client.normalizePath
export type { RequestOptions }
export default request
